import React from 'react';
import classNames from 'classnames';
import * as PropType from '../common/propType';

import './index.less';

export interface IImagePropType extends PropType.RadiusPropType, PropType.RectPropType, PropType.StylePropType {
    circle?: boolean;
    responsive?: boolean;
    prefixCls?:string;
    onClick?: () => void;
    src: any;
}

class Image extends React.Component<IImagePropType, any> {
    static defaultProps: IImagePropType = {
        radius: false,
        round: false,
        responsive: true,
        prefixCls: 'img',
        src: null,
    };

    render() {
        const {radius, round, onClick, responsive, circle, className, src, prefixCls} = this.props;

        let clsName = classNames(
            prefixCls,
            {
                [`${prefixCls}-radius`]: !!radius,
                [`${prefixCls}-round`]: round,
                [`${prefixCls}-circle`]: circle,
                [`${prefixCls}-responsive`]: responsive
            },
            className
        );

        let style = PropType.getStyle(this.props);

        return (<img src={src} onClick={onClick} className={clsName} style={style} />)
    }
}

export default Image;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/image/index.tsx